import React, { Component } from 'react';
import i18n from '@i18next/i18n';
import ToolbarItemImage from '@com-m/tool-bar-m/toolbar-item-image';
import isEqual from 'lodash/isEqual';
import { ITextEditItemsData } from './textEditDataProcesser';
import styles from './index.css';
import { MenuType } from '@src/slide/domain/ui-model/constant/menu';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';

interface IEditPanelProps {
    textEditData: ITextEditItemsData;
    menuManager?: IMenuManager;
}
export default class TextStyleItems extends Component<IEditPanelProps> {
    public shouldComponentUpdate(nextProps) {
        const lastData = this.props?.textEditData;
        return !isEqual(nextProps?.textEditData?.editFontItemsData, lastData?.editFontItemsData)
            || !isEqual(nextProps?.textEditData?.editAlignItemsData, lastData?.editAlignItemsData)
            || !isEqual(nextProps?.textEditData?.editItemNumberItemsData, lastData?.editItemNumberItemsData);
    }
    public render() {
        const { textEditData } = this.props;
        if (!textEditData?.editFontItemsData) {
            return null;
        }

        return <React.Fragment>
            <div className={styles['first-line-text-item-title']}>{i18n.t('文字样式')}</div>
            <div className={styles['text-item-container']}>{textEditData.editFontItemsData.map((item, i) => (
                <ToolbarItemImage
                    key={i}
                    {...item}
                    style={{ flex: '0 0 64px', height: '41px', margin: 0 }}
                    handleTouchStart={this.handleTouchStart}
                    handleMouseDown={this.handleMouseDown}
                />
            ))}</div>
            <div className={styles['text-item-container']}>{textEditData.editAlignItemsData.map((item, i) => (
                <ToolbarItemImage
                    key={i}
                    {...item}
                    style={{ flex: '0 0 46px', height: '41px', margin: 0 }}
                    handleTouchStart={this.handleTouchStart}
                    handleMouseDown={this.handleMouseDown}
                />
            ))}</div>
            <div className={styles['text-item-container']}>{textEditData.editItemNumberItemsData.map((item, i) => (
                <ToolbarItemImage
                    key={i}
                    {...item}
                    style={{ flex: '0 0 50%', height: '41px', margin: 0 }}
                    handleTouchStart={this.handleTouchStart}
                    handleMouseDown={this.handleMouseDown}
                />
            ))}</div>
        </React.Fragment>;
    }
    public handleTouchStart = (id, value) => {
        const callback = this.props.menuManager?.stylePanelMenu().callback;
        callback?.(MenuType.TOOLBAR, id, value);
    };
    public handleMouseDown = (id, value) => {
        this.handleTouchStart(id, value);
    };
}
